<script>
import { formatTimestamp } from '../utils/formatTimestamp'
import { api } from '../../../firebase'
import { toDataUri } from '../../../helpers/toDataUri'

export default {
  name: 'MobilizeV2ImageTemplateDetail',
  async mounted() {
    await this.load()
  },
  data() {
    return {
      loadingState: {
        pending: false,
        done: false,
        error: null
      },
      imageTemplate: null,
      toggleState: {
        pending: false,
        done: false,
        error: null
      },
      rendered: ''
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    imageDataUri() {
      return this.imageTemplate ? toDataUri(this.imageTemplate.data.image, 'image/svg+xml') : null
    },
    createdDateTime() {
      return this.imageTemplate ? formatTimestamp(this.imageTemplate.createTime) : null
    },
    lastModifiedDateTime() {
      return this.imageTemplate ? formatTimestamp(this.imageTemplate.updateTime) : null
    }
  },
  methods: {
    async load() {
      this.loadingState = {
        pending: true,
        done: false,
        error: null
      }
      try {
        const id = this.id
        const { result } = await api.imageTemplates.findById({ id })
        this.imageTemplate = result
        this.loadingState.done = true
      } catch (error) {
        this.loadingState.error = error
      } finally {
        this.loadingState.pending = false
      }
    },
    async disable() {
      try {
        const { result } = await api.imageTemplates.disable({ id: this.id })
        this.imageTemplate = result
        this.$toast.success('Image template disabled successfully.')
      } catch (_) {
        this.$toast.error('Disabling the image template failed. Please try again.')
      }
    },
    async enable() {
      try {
        const { result } = await api.imageTemplates.enable({ id: this.id })
        this.imageTemplate = result
        this.$toast.success('Image template enabled successfully.')
      } catch (_) {
        this.$toast.error('Enabling the image template failed. Please try again.')
      }
    },
    async render() {
      try {
        const { image } = await api.imageTemplates.render({
          imageTemplate: this.id,
          // TODO: Improve this to support selecting more events?
          event: '003PzKZZWsYgabGKsT7A',
          output: { format: 'png' },
          cache: {
            read: false,
            write: false
          }
        })
        this.rendered = image
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<template>
  <div class="mobilizev2-view detail">
    <h1>Image Template</h1>

    <div v-if="loadingState.pending">
      <v-alert>Loading...</v-alert>
    </div>
    <div v-else-if="loadingState.error">
      <v-alert outlined color="red">
        <p>An error occurred while loading the image template.</p>
        <p>{{ loadingState.error.message }}</p>
      </v-alert>
    </div>
    <div v-else-if="loadingState.done">
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <td>ID</td>
              <td>{{ imageTemplate.id }}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>{{ imageTemplate.data.name }}</td>
            </tr>
            <tr>
              <td>Enabled</td>
              <td>{{ imageTemplate.data.enabled ? 'Yes' : 'No' }}</td>
            </tr>
            <tr>
              <td>Image</td>
              <td><img class="preview" :src="imageDataUri" /></td>
            </tr>
            <tr>
              <td>Created</td>
              <td>{{ createdDateTime }}</td>
            </tr>
            <tr>
              <td>Last modified</td>
              <td>{{ lastModifiedDateTime }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div>
        <v-btn class="disable" v-if="imageTemplate.data.enabled" color="red" outlined @click="disable">
          <v-icon left dark>block</v-icon>
          Disable
        </v-btn>
        <v-btn class="enable" v-else color="green" outlined @click="enable">
          <v-icon left dark>done</v-icon>
          Enable
        </v-btn>

        <v-btn color="primary" @click="render">
          Render
        </v-btn>
        <img v-if="rendered" :src="rendered" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block {
  display: block;
}

.my-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.preview {
  max-height: 600px;
  max-width: 100%;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eee;
  width: 600px;
  height: 600px;
}

.enable,
.disable {
  margin-right: 20px;
}
</style>
